module.exports = __webpack_public_path__ + "img/buddy_nose-04.b5540ae6.svg";